import axios from 'axios';
import routes from '../../../app/routes';

/* const prepareFormDataForSend = (values) => {
  let formData = {
    first_name: values.firstName,
    last_name: values.lastName,
    email: values.email,
    password: values.password,
  };
  return formData;
}; */

export const Actions = {
  load: (dispatch, enterpriseId) => {
    axios.get(routes.api.enterprises.policy(enterpriseId)).then((resp) => {
      dispatch({ type: 'load', policy: resp.data.data });
    });
  },
  createPolicy: (dispatch, enterpriseId, values) => {
    axios
      .post(routes.api.policies.create, {
        enterprise_id: enterpriseId,
        ...values,
      })
      .then((resp) => {
        dispatch({ type: 'createPolicy', policy: resp.data.data });
      });
  },
  updatePolicy: (
    dispatch,
    enterpriseId,
    policyId,
    values,
    successCallback,
    errorCallback,
  ) => {
    axios
      .put(routes.api.policies.update(policyId), {
        enterprise_id: enterpriseId,
        ...values,
      })
      .then((resp) => {
        dispatch({ type: 'updatePolicy', policy: resp.data.data });
        successCallback();
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },
  unlockPolicy: (dispatch, enterpriseId, policyId, successCallback) => {
    axios
      .put(routes.api.policies.unlock(policyId), {
        enterprise_id: enterpriseId,
      })
      .then((resp) => {
        dispatch({ type: 'updatePolicy', policy: resp.data.data });
        successCallback();
      });
  },
  isPossibleCreatePlan: (policyTemplateId, enterpriseId, successCallback) => {
    axios
      .post(routes.api.policy_plans.possible_start, {
        policy_plan_template_id: policyTemplateId,
        enterprise_id: enterpriseId,
      })
      .then((resp) => {
        successCallback(resp.data.data);
      });
  },
  prepareTemplate: (enterpriseId, values, callback) => {
    axios
      .get(routes.api.policy_plans.new, {
        params: {
          template: values.template,
          enterprise_id: enterpriseId,
          plan: values.planId,
        },
      })
      .then((resp) => {
        callback(resp.data.data);
      });
  },
  createPlan: (
    dispatch,
    enterpriseId,
    values,
    successCallback,
    errorCallback,
  ) => {
    axios
      .post(routes.api.policy_plans.create, {
        enterprise_id: enterpriseId,
        policy_plan: values,
      })
      .then((resp) => {
        dispatch({ type: 'load', policy: null });
        successCallback();
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },

  updatePlan: (
    dispatch,
    enterpriseId,
    planId,
    values,
    successCallback,
    errorCallback,
  ) => {
    axios
      .put(routes.api.policy_plans.update(planId), {
        enterprise_id: enterpriseId,
        policy_plan: values,
      })
      .then((resp) => {
        dispatch({ type: 'load', policy: null });
        successCallback();
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },

  destroyPlan: (dispatch, enterpriseId, planId, callback) => {
    axios
      .delete(routes.api.policy_plans.destroy(planId), {
        params: { enterprise_id: enterpriseId },
      })
      .then((resp) => {
        dispatch({ type: 'load', policy: null });
        callback();
      });
  },

  activatePlan: (dispatch, enterpriseId, planId, callback) => {
    axios
      .post(routes.api.policy_plans.activate(planId), {
        enterprise_id: enterpriseId,
      })
      .then((resp) => {
        dispatch({ type: 'load', policy: null });
        callback();
      });
  },
  renewalPlan: (dispatch, enterpriseId, planId, callback) => {
    axios
      .post(routes.api.policy_plans.renewal(planId), {
        enterprise_id: enterpriseId,
      })
      .then((resp) => {
        dispatch({ type: 'load', policy: null });
        callback();
      });
  },
  createDocument: (
    dispatch,
    enterpriseId,
    values,
    successCallback,
    errorCallback,
  ) => {
    const formData = new FormData();
    formData.append('policy_document[file]', values.file, values.file.name);
    formData.append('policy_document[title]', values.title);
    formData.append('enterprise_id', enterpriseId);
    if (values.terms_and_conditions) {
      formData.append('policy_document[document_type]', 'terms_and_conditions');
    }

    axios
      .post(routes.api.policy_documents.create, formData)
      .then((resp) => {
        dispatch({ type: 'load', policy: null });
        successCallback();
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },
  deleteDocument: (dispatch, enterpriseId, documentId, callback) => {
    axios
      .delete(routes.api.policy_documents.destroy(documentId), {
        params: { enterprise_id: enterpriseId },
      })
      .then((resp) => {
        callback();
      });
  },
  setViewMode: (dispatch, viewMode) => {
    dispatch({ type: 'setViewMode', viewMode });
  },
};
